import Vue from "vue";
import Vuex from "vuex";
import users from "./Users";
import settings from "./Settings";
import businessUnits from "./BusinessUnits";
import costCenters from "./CostCenters";
import subscriptions from "./Subscriptions";
import membresiaForm from "./MembresiaForm";
import subscriptionLink from "./SubscriptionLink";
import subscriber from "./Subscriber";
import subscribers from "./Subscribers";
import products from "./Products";
import paymentForm from "./PaymentForm";
import paymentLink from "./PaymentLink";
import paymentLinks from "./PaymentLinks";
import transactions from "./Transactions";
import customers from "./Customers";
import subscriberPaymentEditLink from "./SubscriberPaymentEditLink";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    settings,
    businessUnits,
    costCenters,
    subscriber,
    subscribers,
    subscriberPaymentEditLink,
    products,
    paymentForm,
    paymentLink,
    paymentLinks,
    subscriptions,
    membresiaForm,
    subscriptionLink,
    transactions,
    customers
  },
  state: {},
  mutations: {},
  actions: {}
});
